// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorDistributorPriceLists = (client) => ({
    /**
     * `POST /vendor/distributor-price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdProductsCreate
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/products/route.ts
     */
    createProduct: (id, body, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id/products", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/distributor-price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdDelete
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/distributor-price-lists/:id/products/:product_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdProductsProductIdDelete
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/products/[product_id]/route.ts
     */
    deleteProduct: (id, productId, body, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id/products/:product_id", [id, productId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/distributor-price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdProductsRetrieve
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /vendor/distributor-price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdPut
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id", [id]), { method: "PUT", body, query, headers }),
    /**
     * `PUT /vendor/distributor-price-lists/:id/products/:product_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDistributorPriceListsIdProductsProductIdPut
     * @source apps/backend/src/api/vendor/distributor-price-lists/[id]/products/[product_id]/route.ts
     */
    updateProduct: (id, productId, body, query, headers) => client.fetch(buildPath("/vendor/distributor-price-lists/:id/products/:product_id", [id, productId]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=distributor-price-lists.js.map